// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"b2130c2c","453":"1d0692ef"}[chunkId] + ".chunk.js";
};